import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, Field, change } from 'redux-form';
import { Radio, TextArea, VERTICAL_GROUP } from '../../../components/Form';

const TYPE_BOTH = 'both';
const TYPE_LEGAL = 'legal';
const TYPE_OFFICE = 'office';

const LABEL_BOTH = 'Juridiskā un biroja';
const LABEL_LEGAL = 'Juridiskā';
const LABEL_OFFICE = 'Biroja';

export const TYPE_MAP = {
  [TYPE_BOTH]: LABEL_BOTH,
  [TYPE_LEGAL]: LABEL_LEGAL,
  [TYPE_OFFICE]: LABEL_OFFICE
};

const TYPE_OPTIONS = [
  { value: TYPE_BOTH, label: TYPE_MAP[TYPE_BOTH] },
  { value: TYPE_LEGAL, label: TYPE_MAP[TYPE_LEGAL] },
  { value: TYPE_OFFICE, label: TYPE_MAP[TYPE_OFFICE] },
]

class Address extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onTypeChange: PropTypes.func,
    currentType: PropTypes.string,
  };

  render() {
    const { name, currentType, onTypeChange } = this.props;
    return (
      <fieldset className="list-group-item">
        { onTypeChange && 
          <Field
            component={Radio}
            name={`${name}.type`}
            options={TYPE_OPTIONS}
            onChange={onTypeChange}
            inline
          />}
        <Field
          component={TextArea}
          name={`${name}.address`}
          placeholder="Adrese"
          label={currentType ? `${TYPE_MAP[currentType]} adrese` : null}
          group={{direction: VERTICAL_GROUP}}
        />
      </fieldset>
    )
  }
}


class Addresses extends PureComponent {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    change: PropTypes.func.isRequired,
    secondType: PropTypes.string
  }

  constructor(props) {
    super(props);

    this.onTypeChange = this.onTypeChange.bind(this);
  }

  onTypeChange(e) {
    const { fields, secondType, change } = this.props;
    const t = e.target.value;
    if (t === TYPE_BOTH) {
      // ensure only one field
      if (fields.length === 2){
        fields.remove(1);
      }

    } else {
      const otherType =  t === TYPE_OFFICE ? TYPE_LEGAL : TYPE_OFFICE;
      if (fields.length === 1) {
        fields.push({
          type: otherType
        });
      } else if (secondType !== otherType) {
        change("register_company", "addresses[1].type", otherType);
      }
    }
  }

  render() {
    const { fields, secondType } = this.props;

    return (
      <fieldset className="form-group">
        <legend>Adreses</legend>
        <div className="list-group">
          {/* @TODO errors (vismaz viena adrese)*/}
          {fields.map((address, idx) =>
            <Address
              key={idx}
              name={address}
              onTypeChange={idx === 0 ? this.onTypeChange : null}
              currentType={idx === 1 ? secondType : null}
            />
          )}
        </div>
      </fieldset>
    )
  }
}

const formSelector = formValueSelector('register_company');
const mapStateToProps = (state, props) => ({
  secondType: formSelector(state, 'addresses[1].type')
});

export default connect(mapStateToProps, {change})(Addresses);


// WEBPACK FOOTER //
// ./src/scenes/Registration/CompanyForm/Addresses.js